@use '../../scss/utility';
@use 'fly-in-vars';

:host {
  @include fly-in-vars.wb-fly-in-vars;

  display: block;
  position: fixed;
  pointer-events: none;
  inset: 0;
  z-index: var(--z-index);

  @include utility.breakpoint-from(mq4) {
    @include fly-in-vars.wb-fly-in-desktop-vars;
  }
}

.inner {
  display: block;
  position: absolute;
  overflow: auto;
  pointer-events: auto;
  max-width: 100%;
  max-height: 100%;
  background-color: var(--fly-in-background-color);
  color: var(--fly-in-text-color);
  transition:
    transform 0.5s var(--wb-move),
    box-shadow 0.3s var(--wb-fade);
  box-sizing: border-box;
  padding: var(--padding);
}

:host([from='start']),
:host([from='end']) {
  .inner {
    inset-block: 0;
    width: var(--size);
  }
}

:host([from='top']),
:host([from='bottom']) {
  .inner {
    inset-inline: 0;
    height: var(--size);
  }
}

:host([from='start']) .inner {
  inset-inline-start: 0;
  transform: translate3d(-100%, 0, 0);
}

:host([from='end']) .inner {
  inset-inline-end: 0;
  transform: translate3d(100%, 0, 0);
}

:host([from='top']) .inner {
  inset-block-start: 0;
  transform: translate3d(0, -100%, 0);
}

:host([from='bottom']) .inner {
  inset-block-end: 0;
  transform: translate3d(0, 100%, 0);
}

:host([hide-backdrop]) .inner {
  box-shadow: none !important;
}

:host([is-rtl][from='start']) .inner {
  inset-inline-start: unset;
  inset-inline-end: 0;
  transform: translate3d(100%, 0, 0);
}

:host([is-rtl][from='end']) .inner {
  inset-inline-start: 0;
  inset-inline-end: unset;
  transform: translate3d(-100%, 0, 0);
}

:host([padded]) .inner {
  --padding: var(--fly-in-padding);
}

:host([open]) .inner {
  transform: none;
}

:host([open]:not([hide-backdrop])) .inner {
  box-shadow: 0 0 0 1000vh var(--fly-in-overlay-background-color);
}
